import type { CSSProperties } from 'react';

interface WaveformProps {
  blockSize?: number;
  variant?: 'voice-b' | 'static';
}

function generateBars(): number[] {
  const half = Array.from({ length: 26 }, (_, i) => {
    const base = 0.45 + Math.sin(i * 0.6) * 0.15;
    const spike = i % 7 === 0 || i % 11 === 0 ? 0.2 : 0;
    return Math.max(0.3, Math.min(0.85, base + spike));
  });
  return [...half, ...half.slice().reverse()];
}

const BARS = generateBars();

export default function Waveform({ blockSize, variant = 'voice-b' }: WaveformProps) {
  const wrapperStyle = blockSize !== undefined ? { blockSize: `${blockSize}px` } : undefined;
  return (
    <div
      className={`mkt-hero-tw__waveform mkt-hero-tw__waveform--${variant}`}
      style={wrapperStyle}
      aria-hidden="true"
    >
      {BARS.map((h, i) => {
        const durSec = 4.0 + (i % 3) * 0.6;
        const delaySec = (i * 0.12) % 4.0;
        const animStyle: CSSProperties =
          variant === 'voice-b'
            ? {
                ['--bar-h' as string]: h,
                ['--bar-dur' as string]: `${durSec}s`,
                ['--bar-delay' as string]: `${delaySec}s`,
                willChange: 'transform',
              }
            : { ['--bar-h' as string]: h };
        return (
          <span
            key={i}
            className={`mkt-hero-tw__waveform-bar mkt-hero-tw__waveform-bar--${variant}`}
            style={animStyle}
          />
        );
      })}
    </div>
  );
}

export const STATIC_BARS_COUNT = BARS.length;
